import React, {Component}                       from 'react';
import Field                                    from '../Field';
import SubmitInput                              from '../Fields/SubmitInput';
import HeaderSteps                              from '../Fragments/HeaderSteps';
import SaveForLaterModal                        from '../Fragments/SaveForLaterModal';
import AdditionalDetailsMarketingPermissions    from '../Fragments/AdditionalDetailsMarketingPermissions';
import { browserHistory }                       from 'react-router';

let DomainInfo =                                require('../Managers/DomainInfo');
let HttpService =                               require('../Managers/HttpService');
let Quote =                                     require('../Managers/Quote');

export default class AdditionalDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tenantNumber: 1,
            notEnoughDetails: true,
            isButtonDisabled: false,
            isBankValidationAvailable: false,
            isBankValidationRequired: false,
            isBankValidationActionModalVisible: false,
            isBankValidationInfoModalVisible: false,
            showBankSelection: true,
        };
    }

    componentWillMount() {
        let thirdPartyData = DomainInfo.getThirdPartyData();

        // if we have thirdPartyData, AND its not JSON data, its not agent x, so we need to enable the button
        if (!window.uornorb(Quote.getByPath('domainInfo.thirdParty'))) {
            if (!thirdPartyData.isJson) {
                // If it's not JSON, then they aren't questions, so don't disable the button.
                this.setState({ isButtonDisabled: false });
            } else {
                // Otherwise we do disable the button until the agreements are made by the user.
                this.setState({ isButtonDisabled: true });
            }
        }

        this.setState({ thirdPartyData });
        this.checksForBankValidation();
    }

    componentDidMount() {
        let bankDataProvider = window.localStorage.getItem('BankDataProvider');
        $('html, body').animate({
            scrollTop: $('body').offset().top - $('header.site-header').height()
        }, 500);

        // Only do the gross JS injection if we absolutely need to
        if (Quote.getByPath('BankValidationStrategy.scripts')) {
            let addScript = document.createElement('script');
            addScript.setAttribute('src', Quote.getByPath('BankValidationStrategy.scripts'));
            document.body.appendChild(addScript);
        }
        if (this.state.isBankValidationAvailable === true) {
            Quote.setByPath('BaseIndividualApplication.bankDataProvider', parseInt(bankDataProvider));
        }
    }

    manualStepProgression() {
        browserHistory.push('/application/summary');
    }

    /**
     * Runs checks against product, residential status, employment status and
     * financial referee types to determine if the user is eligible to be
     * shown the bank validation controls, via setting a state.
     *
     * First step (product): Anything other than Insight or Xpress is eligible
     * Second step (residential/employment status): Private tenants, employed, and independent means are always eligible
     * Third step (financial referee type for each financial referee): Employed or Retired is eligible
     */
    checksForBankValidation() {
        let product = Quote.getByPath('BaseIndividualApplication.product.productId');
        let referenceType = Quote.getByPath('BaseIndividualApplication.referenceType');
        let residentialStatus = Quote.getByPath('BaseIndividualApplication.residentialStatus');
        let employmentStatus =  Quote.getByPath('BaseIndividualApplication.employmentStatus');
        let financialReferees = Quote.getByPath('BaseIndividualApplication.financialReferees');
        let bankDataProvider = window.localStorage.getItem('BankDataProvider');

        // If the product isn't 11 (Xpress) or 20 (Insight) or 24 (Inspire credit check) we can check
        // against the next level - letting and financial referee.
        if (product !== 11 && product !== 20 && !(product === 24 && referenceType === 1)) {
            // lettingReferee is 3 (private tenant), or the employmentStatus is
            // 6 (independent means) or 1 (employed) we always show the bank
            // validation and automatically opt the applicant in to it by default.
            if (residentialStatus === 3 || employmentStatus === 6 || employmentStatus === 1) {
                this.setState({
                    isBankValidationAvailable: true,
                    isBankValidationRequired: Quote.getByPath('BankValidationStrategy.actionModalContent') ? true : false
                });
                Quote.setByPath('BaseIndividualApplication.hasAgreedToBankValidation', bankDataProvider != 0 ? true : false);
            } else {
                // Otherwise we loop through the financial referees and only
                // show the bank validation if the financialRefereeType is 2
                // (employer) or 4 (retired).
                if (!window.uornorb(financialReferees)) {
                    financialReferees.map((financialReferee) => {
                        if (financialReferee.financialRefereeType === 2 || financialReferee.financialRefereeType === 4) {
                            this.setState({
                                isBankValidationAvailable: true,
                                isBankValidationRequired: Quote.getByPath('BankValidationStrategy.actionModalContent') ? true : false
                            });
                            Quote.setByPath('BaseIndividualApplication.hasAgreedToBankValidation', bankDataProvider != 0 ? true : false);
                        }
                    });
                }
            }
        } else {
            this.setState({
                isBankValidationAvailable: false,
                isBankValidationRequired: false,
            });
        }
    }

    /**
     * Manages setting of an opt-out for providing bank details - due to
     * originating from an API, this is managed directly instead of via a
     * state switch.
     */
    toggleBankValidationOptOut(field, value) {
        Quote.setByPath('BaseIndividualApplication.hasAgreedToBankValidation', value === true ? false : true);
        this.setState({
            isBankValidationRequired: value === true ? false : true,
            showBankSelection: value === true ? false : true,
        });
    }

    /**
     * Manages setting a value to confirm that the applicant has completed bank
     * validation. This may or may not be called from within the SPA -
     * depending on the implementation strategy - and due to originating from
     * an API, this is managed directly instead of via a state switch.
     */
    completeBankValidation() {
        Quote.setByPath('BaseIndividualApplication.hasCompletedBankValidation', true);
    }

    showBankValidationActionModal(e) {
        e.preventDefault();
        this.setState({ isBankValidationActionModalVisible: true });
    }

    showBankValidationInfoModal(e) {
        e.preventDefault();
        this.setState({ isBankValidationInfoModalVisible: true });
    }

    closeModals(e) {
        e.preventDefault();
        this.setState({
            isBankValidationActionModalVisible: false,
            isBankValidationInfoModalVisible: false,
        });
    }

    render() {
        let FaCross = require('react-icons/lib/fa/close');

        return(
            <div>
                <HeaderSteps current={5} />

                <question-row class="header-row">
                    <h1>Providing additional details</h1>
                </question-row>

                {/* Only show if bank validation is required AND we have a bank validation method saved in localStorage */}
                {this.state.isBankValidationAvailable === true && window.localStorage.getItem('BankValidationStrategy') ?
                    <div>
                        <question-row>
                            <div className="question-main">
                                {/* Introduction to the entire Additional Details step */}
                                <div dangerouslySetInnerHTML={{__html: Quote.getByPath('BankValidationStrategy.stepIntroduction')}} />

                                {/* If there's content available for the infoModal, provide a trigger to show it */}
                                {Quote.getByPath('BankValidationStrategy.infoModalContent') ?
                                    <div>
                                        <a href="#" className="underline" onClick={this.showBankValidationInfoModal.bind(this)}>Find out more</a>
                                        <div className={this.state.isBankValidationInfoModalVisible === true ? 'modal-container modal-active' : 'modal-container'}>
                                            <div className="modal">
                                                <div className="modal-header">
                                                    {Quote.getByPath('BankValidationStrategy.infoModalTitle')}
                                                    <div className="close-cross" onClick={this.closeModals.bind(this)}>
                                                        <FaCross className="pointer" />
                                                    </div>
                                                </div>
                                                <div className="modal-body">
                                                    <div dangerouslySetInnerHTML={{__html: Quote.getByPath('BankValidationStrategy.infoModalContent')}} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                : null}
                            </div>
                        </question-row>

                        <question-row class="has-border has-padding">
                            <div className="question-main">
                                {/* Introduction to the Fast Track (bank validation) section */}
                                <div dangerouslySetInnerHTML={{__html: Quote.getByPath('BankValidationStrategy.fastTrackIntroduction')}} />
                            </div>
                        </question-row>

                        {/* Modal for the bank account validation actions - only shows if we know the user needs to take some actions on this form */}
                        {this.state.isBankValidationRequired === true ?
                            <question-row class="header-row">
                                <div className="question-main">
                                    {Quote.getByPath('BankValidationStrategy.actionButtonText') ?
                                        <a href="#" onClick={this.showBankValidationActionModal.bind(this)} className="btn btn-success btn-jumbo"><span dangerouslySetInnerHTML={{__html: Quote.getByPath('BankValidationStrategy.actionButtonText')}} /></a>
                                    : null}

                                    <div className={this.state.isBankValidationActionModalVisible === true ? 'modal-container modal-active' : 'modal-container'}>
                                        <div className="modal">
                                            <div className="modal-header">
                                                {Quote.getByPath('BankValidationStrategy.actionModalTitle')}
                                                <div className="close-cross" onClick={this.closeModals.bind(this)}>
                                                    <FaCross className="pointer" />
                                                </div>
                                            </div>
                                            <div className="modal-body">
                                                <div dangerouslySetInnerHTML={{__html: Quote.getByPath('BankValidationStrategy.actionModalContent')}} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </question-row>
                        : null}

                        {!window.uornorb(Quote.getByPath('BankValidationStrategy.iframe')) ?
                            <question-row>
                                <div className="question-main">
                                    <div dangerouslySetInnerHTML={{__html: Quote.getByPath('BankValidationStrategy.iframe')}} />
                                </div>
                            </question-row>
                        : null}

                        {/* Allow the user to opt out of providing bank details if they don't want */}
                        <Field
                            fieldName="optOutOfBankValidation"
                            type="checkbox"
                            source={'BaseIndividualApplication'}
                            storageKey="optedOutOfBankValidation"
                            question={'Don\'t want to use the automated service? Simply tick this box to opt out.'}
                            helpText={'Please note that you may need to provide copies of bank statements to support your application.'}
                            callbackFunction={this.toggleBankValidationOptOut.bind(this)}
                            isLabelFirst={false}
                            hasBorder={false}
                            hasPadding={false}
                        />

                        {/* Introduction to the specific bank validation strategy */}
                        {Quote.getByPath('BankValidationStrategy.strategyIntroduction') ?
                            <question-row class="header-row">
                                <div className="question-main">
                                    <div dangerouslySetInnerHTML={{__html: Quote.getByPath('BankValidationStrategy.strategyIntroduction')}} />
                                </div>
                            </question-row>
                        : null}

                        {/* If there's a blob of bank names to choose from, show the selection field */}
                        {Quote.getByPath('BankValidationStrategy.bankList') && this.state.showBankSelection === true ?
                            <Field
                                fieldName={'bankId'}
                                type={'select'}
                                question={'Select your bank'}
                                storageKey={'bankId'}
                                source={'BaseIndividualApplication'}
                                loadingKey={'BaseIndividualApplication.bankId'}
                                loadValues={true}
                                dataValidation={'required_field'}
                                isInt={true}
                                options={Quote.getByPath('BankValidationStrategy.bankList')}
                            />
                        : null}

                        <Field
                            fieldName="additionalDetailsEvidence"
                            question="Use the option below to securely provide documentation to us now"
                            fieldTitle="Uploading documents"
                            titleLevel={2}
                            storageKey="evidence"
                            type="upload"
                            contextInfo={'Additional details evidence'}
                            allowFileUploads={true}
                            allowCameraUploads={true}
                            labelExtra="If you have any additional information, such as payslips, please upload these below. This step is optional but could help speed up your application."
                            source="Case"
                        />

                        <Field
                            type="textarea"
                            fieldName="note"
                            storageKey="note"
                            question="Further information"
                            hasCountdown={true}
                            countdownMax={252}
                            layoutClass="wide-field"
                            source="ApplicationNote"
                        />
                    </div>
                :
                    <div>
                        <question-row class="no-border">
                            <div className="question-main">
                                <p>We&rsquo;re close to getting started on your application. The duration of the referencing process is significantly reduced when we are provided with the full information that supports your application right from the start. Therefore, if you have any further information or supporting documentation that you think may help speed up your application please provide this in the relevant sections below.</p>
                            </div>
                        </question-row>

                        <Field
                            type="textarea"
                            fieldName="note"
                            storageKey="note"
                            question="Notes"
                            hasCountdown={true}
                            countdownMax={252}
                            layoutClass="wide-field"
                            source="ApplicationNote"
                        />

                        <Field
                            fieldName="additionalDetailsEvidence"
                            question="Use the option below to securely provide documentation to us now"
                            storageKey="evidence"
                            type="upload"
                            contextInfo={'Additional details evidence'}
                            allowFileUploads={true}
                            allowCameraUploads={true}
                            source="Case"
                        />
                    </div>
                }

                <SaveForLaterModal
                    ref="SaveForLaterModal"
                />

                {!window.uornorb(Quote.getByPath('domainInfo.thirdParty')) && this.state.thirdPartyData.isJson ?
                    <AdditionalDetailsMarketingPermissions
                        thirdPartyData={this.state.thirdPartyData}
                        shouldEnableSubmitButton={isButtonEnabled => {
                            let isButtonDisabled = !isButtonEnabled;
                            this.setState({ isButtonDisabled });
                        }}
                    />
                : null }


                <SubmitInput
                    label="Next"
                    callbackFunction={this.manualStepProgression.bind(this)}
                    backLink={true}
                    saveForLater={false}
                    disabled={this.state.isButtonDisabled}
                    saveForLaterFunc={() => {
                        HttpService.applicationPutApplication(() => {
                            this.refs.SaveForLaterModal.toggleIsActive();
                        });
                    }}
                    currentNumber={5}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Screens/AdditionalDetails.js